// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__87iyv","content":"LayoutSettings_content__1m6iN"};